import React from 'react';
import './App.css';

const Services = () => {
  return (
    <div className="page-fade-in">
      {/* Header */}
      <div className="container" style={{paddingTop: '6rem', paddingBottom: '4rem'}}>
        <h1 style={{fontSize: '4rem', fontWeight: '800'}}>Our Capabilities.</h1>
        <p style={{fontSize: '1.5rem', color: '#a1a1a1', maxWidth: '800px', marginTop: '1rem'}}>
          We combine deep industry expertise with advanced technology to help you reinvent your business.
        </p>
      </div>

      {/* Service 1: AI */}
      <div style={{borderTop: '1px solid #333', padding: '6rem 0'}}>
        <div className="container hero" style={{minHeight: 'auto', borderBottom: 'none'}}>
          <div className="hero-content">
            <span className="section-label">1. Artificial Intelligence</span>
            <h2 style={{fontSize: '3rem', marginBottom: '1.5rem'}}>AI-Driven Transformation</h2>
            <p style={{color: '#a1a1a1', fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '2rem'}}>
              We don't just build models, we build business value. From predictive analytics to 
              Generative AI agents, we help you deploy systems that scale.
            </p>
                <ul style={{ listStyle: 'disc', color: '#fff', lineHeight: '2', paddingLeft: '20px' }}>
                <li>LLM Integration & Fine-Tuning</li>
                <li>Predictive Maintenance</li>
                <li>Customer Experience Automation</li>
                </ul>
          </div>
          <div className="hero-img-container" style={{height: '400px'}}>
            <img src="https://images.unsplash.com/photo-1555255707-c07966088b7b?auto=format&fit=crop&w=1000&q=80" alt="AI" className="hero-img"/>
          </div>
        </div>
      </div>

      {/* Service 2: Data */}
      <div style={{borderTop: '1px solid #133', padding: '6rem 0', background: '#111'}}>
        <div className="container hero" style={{minHeight: 'auto', borderBottom: 'none'}}>
           {/* Image First for visual interest */}
           <div className="hero-img-container" style={{height: '400px', flex: '0.5', marginRight: '4rem'}}>
            <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1000&q=80" alt="Data" className="hero-img"/>
          </div>
          <div className="hero-content" style={{paddingRight: '0'}}>
            <span className="section-label">2. Data Strategy</span>
            <h2 style={{fontSize: '3rem', marginBottom: '1.5rem'}}>Modern Data Stack</h2>
            <p style={{color: '#a1a1a1', fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '2rem'}}>
              Data is your most valuable asset, but only if it's accessible. We modernize your 
              legacy warehouses into swift, cloud-native data lakes.
            </p>
            <ul style={{listStyle: 'disc', color: '#fff', lineHeight: '2', paddingLeft: '20px'}}>
              <li>Cloud Migration (AWS/Azure)</li>
              <li>Real-time Analytics Dashboards</li>
              <li>Data Governance & Security</li>
            </ul>
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default Services;